import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Apify, ApifyFullScreenLoadingComponent } from '../Apify';
import { StockCard } from '../c/ChartCard';
import { T } from '../traks';

import SearchField from '../c/SearchField';
import { StockExploreCard } from './Explore.js';

var ExploreWBAG = (props) => {
	var sections = [];

	sections.push(
		<Row key="vndjcgfbIUrgmj0i" className="align-items-center pt-5">
			<Col xs="12" className="pb-3">
				<h3><T>Selected austrian stocks</T></h3>
			</Col>
			<StockExploreCard ticker="POST" exchange="WBAG" card_img="/gfx/oesterreich-post-350x136-0.svg" name="Österreichische Post" href="/ticker/WBAG/POST"/>
			<StockExploreCard ticker="FLU" exchange="WBAG" card_img="/gfx/vienna-airport-350x136-0.svg" name="Flughafen Wien" href="/ticker/WBAG/FLU"/>
			<StockExploreCard ticker="WIE" exchange="WBAG" card_img="/gfx/wienerberger-350x136-0.svg" name="Wienerberger" href="/ticker/WBAG/WIE"/>
		</Row>

	);

	for (const section of props.home.Sections) {
		var items = [];

		const mk_stock_item = (asset) => {
			const key = `STOCK:${asset.Exchange}:${asset.Ticker}`;
			return (
				<Col key={key} md="3" className="pb-4">
					<StockCard
						exchange={asset.Exchange}
						ticker={asset.Ticker}
						range="3m"
					/>
				</Col>
			);
		};

		switch (section.Type) {
			case "STOCKS":
				items = section.Content.map(mk_stock_item);
				break;
			default:
				continue;
		}
		sections.push(
				<span key="SPANNING_ALL">
				<Row key={section.Type}>
					<Col xs="12" className="pb-3">
						<h3><T>Random austrian stocks</T></h3>
					</Col>
				</Row>
				<Row>
					{items}
				</Row>
				</span>
		);
	}

	const placeholder = <T>Search Austrian assets</T>;

	return (
		<React.Fragment>
			<div className="d-flex flex-column text-center ad_explore_large_img_wbag justify-content-center">
				<div className="pt-5 text-white ad_explore_txt_header"><T>Austria</T></div>
				<div className="text-white pb-3 ad_explore_txt_subheader px-2"><T>Explore assets exclusively from Austria</T></div>
				<SearchField placeholder={placeholder} market="AT_STOCK" form_classes="justify-content-center pt-2" input_classes="ad_search_explore_page ad_no_outline_focus" input_id="search_field_1"/>
			</div>
			<Container>
				{sections}
			</Container>
		</React.Fragment>
	);
}

ExploreWBAG = Apify("/z/explore?market=AT_STOCK")
	.with_response_prop("home")
	.wrap(ExploreWBAG, ApifyFullScreenLoadingComponent);

export default ExploreWBAG;



// WEBPACK FOOTER //
// ./src/p/ExploreWBAG.js